declare global {
  interface Window {
    gtag: (
      command: "event" | "config" | "js",
      action: string,
      params?: Record<string, unknown>
    ) => void;
  }
}

export const GA_MEASUREMENT_ID = "G-3R40YN17G4";
export const ADS_CONVERSION_ID = "AW-1051216162";

export const ADS_LABELS = {
  BUY_NOW: "IzykCK2Y96QBEKKSofUD",
  CONTACT_FORM: "5ZoJCP7jsboaEKKSofUD",
  VEHICLE_VIEW: "woNFCPvjsboaEKKSofUD",
  INQUIRY_FORM: "Dm4YCPjjsboaEKKSofUD",
} as const;

function gtag(...args: Parameters<Window["gtag"]>) {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag(...args);
  }
}

export function trackEvent(
  eventName: string,
  params?: Record<string, unknown>
) {
  gtag("event", eventName, params);
}

export function trackConversion(
  label: string,
  params?: Record<string, unknown>
) {
  gtag("event", "conversion", {
    send_to: `${ADS_CONVERSION_ID}/${label}`,
    ...params,
  });
}

export function trackVehicleView(vehicleName: string, vehicleSlug: string) {
  trackEvent("view_item", {
    item_name: vehicleName,
    item_id: vehicleSlug,
  });
  trackConversion(ADS_LABELS.VEHICLE_VIEW);
}

export function trackBuyNow(vehicleName: string, vehicleSlug: string) {
  trackEvent("begin_checkout", {
    item_name: vehicleName,
    item_id: vehicleSlug,
  });
  trackConversion(ADS_LABELS.BUY_NOW, {
    transaction_id: "",
  });
}

export function trackInquirySubmit(vehicleName: string, vehicleSlug: string) {
  trackEvent("generate_lead", {
    item_name: vehicleName,
    item_id: vehicleSlug,
    lead_type: "inquiry",
  });
  trackConversion(ADS_LABELS.INQUIRY_FORM);
}

export function trackBuyNowCompletion(transactionId: string) {
  trackEvent("purchase", {
    transaction_id: transactionId,
  });
  trackConversion(ADS_LABELS.BUY_NOW, {
    transaction_id: transactionId,
  });
}

export function trackContactSubmit() {
  trackEvent("generate_lead", {
    lead_type: "contact",
  });
  trackConversion(ADS_LABELS.CONTACT_FORM);
}
